<h2 mat-dialog-title>{{ data.title }}</h2>
<mat-dialog-content class="mat-typography">
  <p>{{ data.message }}</p>
</mat-dialog-content>
<mat-dialog-actions align="end">
  <button mat-button (click)="handleClose()">Cerrar</button>
  <button mat-flat-button color="primary" (click)="handleNavigate()">
    Ir a {{ data.actionLabel }}
  </button>
</mat-dialog-actions>
